import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid'
import { Link } from 'gatsby';
import Button from './button';

const LinkBaseStyle = styled('a', { shouldForwardProp: prop =>
    isPropValid(prop)
})(props => ({
  textAlign: 'center',
  alignItems: 'center',
  display: 'inline-block',
  color: props.white ? `white` : props.theme.primary,
  textDecoration: 'none',
  [`:hover`]: {
    textDecoration: props.underline ? `underline` : `none`
  }
}));

const InternalLink = LinkBaseStyle.withComponent(Link);
const OutboundLink = LinkBaseStyle.withComponent('a');
const InternalLinkButton = Button.withComponent(InternalLink);
const OutboundLinkButton = Button.withComponent(OutboundLink);

export { Link, InternalLink, OutboundLink, InternalLinkButton, OutboundLinkButton };
